export default "__VITE_ASSET__1de29927__"